<template>
  <div>
    <h3>Pembayaran Pinjaman</h3>
    <form @submit.prevent="handleSubmit">
      <div class="form-group">
        <label>Bayar Pinjaman:</label>
        <select v-model="form.loan_id" required>
          <option v-for="loan in activeLoans" :key="loan.id" :value="loan.id">
            {{ loan.purpose }} (Sisa: Rp {{ formatCurrency(loan.amount) }})
          </option>
        </select>
      </div>
      <div class="form-group">
        <label>Dari Rekening Tabungan:</label>
        <select v-model="form.from_account_id" required>
           <option v-for="acc in savingsAccounts" :key="acc.id" :value="acc.id">
            {{ acc.account_type }} (Saldo: Rp {{ formatCurrency(acc.balance) }})
          </option>
        </select>
      </div>
      <div class="form-group">
        <label>Jumlah Pembayaran:</label>
        <input v-model.number="form.amount" type="number" required />
      </div>
      <button type="submit" class="btn btn-primary">Bayar</button>
    </form>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'; // <-- IMPOR 'ref'
import api from '@/services/api';
import { useToast } from 'vue-toastification';

const props = defineProps({
  activeLoans: Array,
  savingsAccounts: Array,
});
const emit = defineEmits(['repayment-success']);
const toast = useToast();

const form = reactive({
  loan_id: props.activeLoans[0]?.id || null,
  from_account_id: props.savingsAccounts[0]?.id || null,
  amount: null,
});

const isSubmitting = ref(false);
const handleSubmit = async () => {
  try {
    await api.repayLoan(form.loan_id, {
      from_account_id: form.from_account_id,
      amount: form.amount
    });
    toast.success("Pembayaran pinjaman berhasil.");
    emit('repayment-success');
  } catch (error) {
    const detail = error.response?.data?.detail || "Terjadi kesalahan.";
    toast.error(`Gagal: ${detail}`);
    console.error('Pengajuan pinjaman gagal:', error);
  } finally {
    isSubmitting.value = false;
  }
};

const formatCurrency = (value) => {
  const num = parseFloat(value);
  return isNaN(num) ? '0.00' : num.toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
</script>

<style scoped>

  .loan-form-container { 
    margin-top: 2rem; 
    padding: 1.5rem; 
    background-color: #fff; 
    border: 1px solid #e0e0e0;
    border-radius: 8px;
  }
</style>